export default __webpack_public_path__ + "static/media/ninjaprinthouse-logo.1b23c6f7.png";